import { resolveI18n } from "../../../commons/services/Translation"

export const PowerSystemInfoCardColumnWidth = (i18n) => {
  return {
    position: {
      pvLeft: resolveI18n({ i18n, ko: '248px', en: '228px', vi: '208px' }), 
      essLeft: resolveI18n({ i18n, ko: '654px', en: '634px', vi: '614px' }),
      chargingLeft: resolveI18n({ i18n, ko: '228px', en: '208px', vi: '188px' }),
      dischargingLeft: resolveI18n({ i18n, ko: '654px', en: '634px', vi: '634px' }),
    },
    titleWidth: resolveI18n({ i18n, ko: '41px', en: '70px', vi: '80px' }),
  }
}

